<template>
  <wizard-form v-bind="ouiaProps" :hidden="hidden" :title="$t('Scelta dello stack')">
    <pf-grid gutter>
      <pf-grid-item sm="6" v-if="wizard.askStack" style="max-width: 700px">
        <wizard-question :title="$t('Quale stack vuoi attivare?')">
          <wizard-question-stack v-model="wizard.stack" required />
        </wizard-question>
      </pf-grid-item>

      <pf-grid-item sm="6" style="max-width: 80ch">
        <wizard-question v-if="wizard.askEssentialOs" :title="$t('Sistema operativo')">
          <template #description>{{ $t('Quale sistema operativo vorresti che ti venisse installato?') }}</template>
          <wizard-question-options v-model="wizard.essentialOs" :options="wizard.cloudOperativeSystems" name="essentialOs" required :is-popup="wizard.modal" />
          <pf-grid>
            <pf-grid-item :sm="gridSpan('4')" :lg="gridSpan('3')">
              <pf-radio
                :label="$t('Altro, specificare')"
                name="essentialOs"
                required
                value="altro"
                :checked="wizard.essentialOs === 'altro'"
                @change="wizard.essentialOs = 'altro'"
                data-ouia-component-id="wizard-stack-essentialOs"
              />
            </pf-grid-item>
            <pf-grid-item sm="8" lg="9" style="max-width: 400px">
              <x-input
                :disabled="wizard.essentialOs !== 'altro'"
                name="essentialOtherOs"
                v-model="wizard.essentialOtherOs"
                required
                :placeholder="$t('Sistema operativo')"
              />
            </pf-grid-item>
          </pf-grid>
        </wizard-question>

        <template v-else-if="wizard.askCockpitConfig">
          <wizard-question :title="$t('Sistema operativo')">
            <template #description>{{ $t('Quale sistema operativo vorresti che ti venisse installato?') }}</template>
            <wizard-question-options v-model="wizard.cockpitOs" :options="wizard.cloudOperativeSystems" name="cockpitOs" required :is-popup="wizard.modal" />
          </wizard-question>
          <wizard-question :title="$t('Web Server')">
            <template #description>{{ $t('Quale web server vorresti che ti venisse installato?') }}</template>

            <wizard-question-options v-model="wizard.cockpitWs" :options="wizard.opzioniWebServers" name="cockpitWs" required :is-popup="wizard.modal" />
          </wizard-question>
        </template>

        <template v-else-if="wizard.askAddonCpanel">
          <wizard-question :title="$t('Vuoi attivare una licenza Imunify360?')">
            <wizard-question-prodotto v-model="wizard.addonImunify" :product="wizard.getProdotto(wizard.codiceProdottoImunify)" show-prezzo show-utenti />
          </wizard-question>
          <wizard-question :title="$t('Vuoi attivare una licenza LiteSpeed?')">
            <wizard-question-prodotto v-model="wizard.addonLiteSpeed" :product="wizard.getProdotto(wizard.codiciProdottiAddon.liteSpeed)" show-prezzo />
          </wizard-question>
        </template>

        <template v-else-if="wizard.askAddonWindows">
          <wizard-question :title="$t('Vuoi attivare una licenza terminal server?')">
            <wizard-question-prodotto
              v-model="wizard.addonTerminalServer"
              v-model:qt="wizard.terminalServerQt"
              :product="wizard.getProdotto(wizard.codiciProdottiAddon.terminalServer)"
              show-prezzo
              ask-qt
            />
          </wizard-question>
          <wizard-question :title="$t('Vuoi attivare una licenza SQL Server?')">
            <pf-radio
              :checked="wizard.codiceLicenzaSql === undefined"
              @change="wizard.codiceLicenzaSql = undefined"
              name="codiceProdottoSql"
              :value="undefined"
              :label="$t('No')"
            />
            <wizard-question-prodotti
              v-model="wizard.codiceLicenzaSql"
              :prodotti="wizard.codiciProdottiSql"
              :qt="Math.round(wizard.cpuCloudQt / 2)"
              ask-qt
              fixed-qt
              :price-help="$t('Prezzo calcolato in base al numero di cpu del server')"
              name="codiceProdottoSql"
            />
          </wizard-question>
        </template>
      </pf-grid-item>
    </pf-grid>
  </wizard-form>
</template>

<script lang="ts" setup>
import { useOUIAProps, type OUIAProps } from '@common/ouia';
import { useWizardStep } from '@/wizard';

import WizardQuestion from '../questions/wizard-question.vue';
import WizardQuestionProdotti from '../questions/wizard-question-prodotti.vue';
import WizardQuestionProdotto from '../questions/wizard-question-prodotto.vue';
import WizardQuestionStack from '../questions/wizard-question-stack.vue';
import WizardQuestionOptions from '../questions/wizard-question-options.vue';
import WizardForm from '../wizard-form.vue';
import type { GridSpan } from '@vue-patternfly/core/layouts/Grid/Grid.vue';

defineOptions({
  name: 'WizardStepStack',
});

const props = defineProps<OUIAProps>();
const ouiaProps = useOUIAProps(props);

const { wizard, hidden, isEnabled } = useWizardStep({
  isEnabled: wizard => wizard.askStack,
});

defineExpose({
  isEnabled,
});

function gridSpan(span: GridSpan) {
  return wizard.modal ? '12' : span;
}
</script>
